/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const FilePdfLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 16H8V8h4a4 4 0 0 1 0 8m-2-6v4h2a2 2 0 1 0 0-4zm5-6H5v16h14V8h-4zM3 3a1 1 0 0 1 1-1h12l5 5v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />
  </Icon>
);
